export class RisModalityDeviceModel {
  ModalityDeviceId: number;
  OrgId?: number;
  DeviceName: string;
  DeviceAeTitle: string;
  DeviceIp: string;
  DevicePort?: number;
  SenderAiTitle: string;
  LocalPacsHost: string;
  LocalPacsPort?: number;
  LocalPacsUsetls?: boolean;
  LocalPacsCallingae: string;
  LocalPacsCalledae: string;
  ModalityId?: number;
  ModalityName: string;
  IsActive?: boolean;
  CreatedBy?: number;
  CreatedOn?: Date;
  LastModifiedBy?: number;
  LastModifiedOn?: Date;
}
